<template>
  <div
    class="v-view chart-view a-fadeIn"
    :style="{ height: span * 33.33 + '%' }"
  >
    <div class="v-title">{{ title }}</div>

    <v-chart
      v-if="pieData.length > 0"
      ref="chart"
      class="cv-chart"
      :options="pieOption"
      @mouseover="onMouseOver"
      @globalout="onGlobalOut"
      autoresize
    ></v-chart>
    <div v-else class="cv-nodata">暂无数据!</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "echarts/lib/chart/pie";
import "echarts/lib/component/legend";

export default {
  name: "JCElderAbility",
  computed: {
    ...mapGetters(["cid"]),
    chart() {
      return this.$refs.chart && this.$refs.chart["chart"];
    },
  },
  props: {
    type: {
      type: String,
      default: "pie",
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: "能力评估情况",
    },
  },
  watch: {
    pieData(data) {
      this.pieOption.dataset.source = data.map((item) => ({
        name: item.Name,
        value: item.Value,
      }));
      this.$nextTick(() => {
        if (this.chart && !this.pieInterval) this.startAnimation();
      });
    },
  },
  data() {
    const ability = this.$configer.ability;
    return {
      dataIndex: -1,
      pieInterval: null,
      pieOption: {
        color: ["#00afe4", "#ff2839", "#00fc3a", "#e7df00"],
        legend: {
          show: true,
          top: "middle",
          right: "5%",
          orient: "vertical",
          itemWidth: 20,
          itemHeight: 10,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          label: {
            formatter: (data) => {
              let item = "";
              for (let index = 0; index < ability.length; index++) {
                const element = ability[index];
                if (element.name == data) {
                  // item = `{${data}} {a|${element.value}}人`
                  item = element.value;
                }
              }
              return "{" + data + "} {a|" + item + "}" + "人";
            },
            rich: {
              a: {
                color: "red",
                fontSize: 16,
                fontWeight: "bold",
              },
            },
          },
        },
        dataset: {
          source: ability,
        },
        series: [
          {
            type: "pie",
            name: "老人能力等级分布",
            center: ["38%", "50%"],
            radius: ["55%", "75%"],
            label: {
              show: false,
              padding: [10, 5],
              position: "center",
              formatter: function (data) {
                return (
                  data.data.name +
                  "\n" +
                  data.data.value +
                  "人\n" +
                  data.percent +
                  "%"
                );
              },
              backgroundColor: "rgba(0,0,0,0.3)",
              emphasis: {
                show: true,
                fontSize: 15,
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "#0096ff",
            },
            encode: {
              itemName: "name",
              value: "value",
            },
          },
        ],
      },
      pieData: [1, 2, 3],
    };
  },
  created() {
    // this.getElderAbilityData(this.cid)
  },
  beforeDestroy() {
    if (this.pieInterval) {
      clearInterval(this.pieInterval);
      this.pieInterval = null;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.chart && !this.pieInterval) this.startAnimation();
    });
  },
  methods: {
    onMouseOver() {
      if (this.pieInterval) {
        this.chart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: this.dataIndex,
        });
        clearInterval(this.pieInterval);
        this.pieInterval = null;
      }
    },
    onGlobalOut() {
      !this.pieInterval && this.startAnimation();
    },
    startAnimation() {
      const dataLen = this.pieData.length;
      if (dataLen > 1) {
        this.pieInterval = setInterval(() => {
          this.chart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: this.dataIndex,
          });
          if (this.dataIndex < dataLen - 1) {
            this.dataIndex++;
          } else {
            this.dataIndex = 0;
          }
          this.chart.dispatchAction({
            type: "highlight",
            seriesIndex: 0,
            dataIndex: this.dataIndex,
          });
        }, 3000);
      }
    },
    getElderAbilityData(cid) {
      this.$api
        .getElderAbilityDist(cid)
        .then((data) => {
          // console.log(data)
          if (!data || !data.length) return;
          this.pieData = data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
